import { DynamicTextComponent } from '../../dynamic-text/dynamic-text-component';
import { BulletListItem } from '../types';

import styles from '../dynamic-bullet-list.module.scss';

export function getRewardsRatesItems(selectedOffer: any): BulletListItem[] {
  if (!selectedOffer || !selectedOffer.rewardsRates) return [];

  return selectedOffer.rewardsRates.map((item: any, index: number) => ({
    id: `${index + 1}`,
    text: item.description,
    customListMarker: item.rate.toString(),
  }));
}

function rewardsRates({
  items = [],
  listItemsStyle,
  rateAnnotation,
  fontProperties = { fontSize: 16 },
}: {
  items?: BulletListItem[];
  listItemsStyle?: React.CSSProperties;
  rateAnnotation?: string;
  fontProperties?: {
    fontSize: number;
    tablet?: {
      fontSize: number;
    };
    mobile?: {
      fontSize: number;
    };
  };
}) {
  return (
    <div className={styles.rewardsRatesList}>
      <ul style={{ ...listItemsStyle }}>
        {items.map((item, index) => {
          const listMarker = item.customListMarker;
          const sanitizedItem = {
            id: item.id || `${index + 1}`,
            text: item.text || '',
            ...fontProperties,
          };
          return (
            <li key={sanitizedItem.id}>
              {listMarker ? (
                <span className={styles.rewardsRatesListMarker}>
                  {listMarker}
                  {rateAnnotation}
                </span>
              ) : null}
              <DynamicTextComponent {...sanitizedItem} />
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default rewardsRates;
